import HorairesFooter from './HorairesFooter.view';

export default HorairesFooter;
